import { useEffect } from 'react'

import { useDocumentTitleStore } from './document-title-store'
import { formatDocumentTitle } from './format-document-title'

export function useDocumentTitleWriter(): void {
  useEffect(() => {
    const write = () => {
      const { segments, unreadCount } = useDocumentTitleStore.getState()
      document.title = formatDocumentTitle(segments, unreadCount)
    }
    write()
    return useDocumentTitleStore.subscribe(write)
  }, [])
}
